import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { CompaniesApiService, UpdateCompanyDTO } from 'features/companies';
import i18n from 'locales/i18n';
import { queryClient } from 'providers';

import { companiesQueryKeys } from './query-keys';

const { updateCompany } = CompaniesApiService();

export const useUpdateCompany = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: UpdateCompanyDTO) => {
      return updateCompany(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: (data, variables) => {
        Promise.all([
          queryClient.invalidateQueries({
            queryKey: companiesQueryKeys.lists(),
          }),
          queryClient.invalidateQueries({
            queryKey: companiesQueryKeys.detail(variables.id),
          }),
        ]);
        message.success(i18n.t('companies.update.successfulUpdate'));
      },
    },
  );
};
